import buildConfig from '../build-config.json';
import { fetch } from '../utility/fetch';
import { HTTP_STATUS } from './constants';
import { ReproWebMessageSchema as ResponseJSON } from '../generated/repro.rails/v1-internal-web-message';

interface Params {
  userId: string;
  token: string;
  messageId: string;
  serviceName: string;
}

const buildSearchParams = (params: Params): URLSearchParams => {
  const { userId, token, messageId, serviceName } = params;
  const searchParams = new URLSearchParams();

  searchParams.set('service_user_id', userId);

  searchParams.set('token', token);
  searchParams.set('encoded_id', messageId);
  searchParams.set('service_name', serviceName);

  return searchParams;
};

export const fetchMessage = async (params: Params) => {
  if (!navigator.onLine) {
    return Promise.reject(new Error('Aborting Message API call due to browser being offline.'));
  }

  const url = new URL(buildConfig.messageApiURL);
  url.search = buildSearchParams(params).toString();

  const response = await fetch(url.href, {
    headers: { 'Content-Type': 'application/json' },
    mode: 'cors',
  });

  if (response.status === HTTP_STATUS.GONE) {
    throw new Error('Message API call failed due to passing invalid messsage information');
  }
  if (response.status === HTTP_STATUS.UNAUTHORIZED) {
    throw new Error('Message API call failed due to authentication error. Check your repro token.');
  }
  if (!response.ok) {
    throw new Error(`Message API call failed with status ${response.status}.`);
  }

  const json: ResponseJSON = await response.json();
  if (typeof json !== 'object') {
    throw new Error(`Invalid message response: ${json}`);
  }
  if (!json.success) {
    throw new Error('Message API call failed due to unexpected error in partner services.');
  }
  const { message } = json.results;
  if ('error' in message) {
    throw new Error(`Message API erorr: ${message.error}`);
  }

  return {
    closeButtonClickTrigger: message.close_button_click_trigger,
    measurements: message.measurements,
    useThirdPartyService: message.use_third_party_service,
    specId: message.spec_id,
    itemNum: message.item_num,
    rawHtml: message.raw_html,
    rawCss: message.raw_css,
    rawJavaScript: message.raw_javascript,
    metadata: 'metadata' in message ? message.metadata : null,
  };
};
